export default __webpack_public_path__ + "static/media/pic2.0d5d185d.jpg";